// Program identity: Program Date + Program Code + Race (docs/adr/0002-program-identity.md).
// Use it for React keys, de-duplication and lookups between datasets. It is not
// a public identifier: anchors and URL paths keep building their own strings.
//
// The tables name the parts differently:
//   pools, summarypools, livepools: programDate, programCode, race. RowKey is the closing time.
//   s*results, s*archive, s*tips:   RowKey (the Program Date), program_code, race.
export const programKey = (item) => {
  const programDate = item.programDate ?? item.RowKey;
  const programCode = item.programCode ?? item.program_code;
  return programDate + "_" + programCode + "_" + item.race;
};
